import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNodeData } from "../../models/CanvasNode.ts";
import LinkHandler from "./LinkHandler.tsx";
import MultiProductDialog from "./MultiProductDialog.tsx";
import { List, LayoutList } from 'lucide-react';

const MultiProduct: React.FC<any> = (data) => {
    const { nodes } = useFlowStore();
    const [showDialog, setShowDialog] = useState(false);

    // Summary state — just enough to show a preview on the node
    const [mode, setMode] = useState<'dynamic' | 'fixed'>('dynamic');
    const [body, setBody] = useState("");
    const [itemCount, setItemCount] = useState(0);
    const [arrayAttribute, setArrayAttribute] = useState("");

    useEffect(() => {
        const node = nodes.find(n => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find(c => c.id === data.subNodeId);
            if (content?.data) {
                const d = content.data as any;
                setMode(d.mode || (d.fixedRows?.length ? 'fixed' : 'dynamic'));
                setBody(d.body || d.text || "");
                setItemCount(d.fixedRows?.length ?? 0);
                setArrayAttribute(d.arrayAttribute || "");
            }
        }
    }, [nodes]);

    const onClose = () => setShowDialog(false);

    return (
        <div style={{ padding: '8px', display: 'flex', flexDirection: 'column', gap: '8px' }}>

            {/* Compact summary */}
            <div style={{
                background: '#f8fafc', borderRadius: '10px', padding: '10px 12px',
                border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '10px'
            }}>
                <div style={{
                    width: '32px', height: '32px', borderRadius: '8px',
                    background: mode === 'fixed' ? '#d1fae5' : '#dbeafe',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                }}>
                    {mode === 'fixed'
                        ? <LayoutList size={16} color="var(--primary-bg-color)" />
                        : <List size={16} color="#1d4ed8" />}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '11px', fontWeight: 600, color: '#0f172a', marginBottom: '2px' }}>
                        {mode === 'fixed'
                            ? `${itemCount || 1} fixed item${itemCount !== 1 ? 's' : ''}`
                            : arrayAttribute ? `From: ${arrayAttribute}` : 'Dynamic list'}
                    </div>
                    {body ? (
                        <div style={{ fontSize: '10px', color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {body}
                        </div>
                    ) : (
                        <div style={{ fontSize: '10px', color: '#f59e0b' }}>Body text not set</div>
                    )}
                </div>
            </div>

            <button
                onClick={() => setShowDialog(true)}
                style={{
                    width: '100%', padding: '7px 0', fontSize: '12px', fontWeight: 500,
                    borderRadius: '8px', border: '1px solid var(--primary-bg-color)',
                    background: 'white', color: 'var(--primary-bg-color)', cursor: 'pointer'
                }}
            >
                Configure List
            </button>

            <LinkHandler />

            <Dialog
                header="Option List"
                visible={showDialog}
                modal
                appendTo={document.body}
                maskStyle={{ background: "rgba(0,0,0,0.5)", zIndex: 9998 }}
                contentStyle={{ zIndex: 9999, padding: '16px 20px' }}
                style={{ width: "520px", maxWidth: "95vw" }}
                onHide={onClose}
            >
                <MultiProductDialog data={data} onClose={onClose} />
            </Dialog>
        </div>
    );
};

export default MultiProduct;
